import {
  DESKTOP_APP_CURRENT_VERSION,
  DESKTOP_APP_LATEST_VERSION,
  DESKTOP_APP_UPDATE_AVAILABLE,
  DESKTOP_APP_UPDATE_MANDATORY,
  MANAGER_NOT_READY,
  MANAGER_READY,
  MANAGER_TRANSPORT_CONNECTED,
  MANAGER_TRANSPORT_DISCONNECTED,
  SET_MANAGER_API_TOKEN,
} from '../types/desktopApp';

/** @typedef {import("../../../global").DesktopAppState} DesktopAppState */

/** @type {DesktopAppState} */
const initialState = {
  latestAppVersion: '',
  currentAppVersion: '',
  appUpdateAvailable: false,
  startedToConnectGIMmanager: false,
  connectionCount: 0,
  isUpdateMandatory: false,
  managerTransportConnected: false,
  managerReady: false,
  managerApiToken: '',
};

/**
 *
 * @param {DesktopAppState} state
 * @param {{payload: any, type: string}} payloadData
 * @returns {DesktopAppState}
 */
const desktopAppReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case DESKTOP_APP_CURRENT_VERSION: {
      return {
        ...state,
        currentAppVersion: payload,
      };
    }
    case DESKTOP_APP_LATEST_VERSION: {
      return {
        ...state,
        latestAppVersion: payload,
      };
    }
    case DESKTOP_APP_UPDATE_AVAILABLE: {
      return {
        ...state,
        appUpdateAvailable: payload,
      };
    }
    case MANAGER_TRANSPORT_CONNECTED: {
      return {
        ...state,
        managerTransportConnected: true,
        connectionCount: 1,
      };
    }
    case MANAGER_TRANSPORT_DISCONNECTED: {
      return {
        ...state,
        managerTransportConnected: false,
        connectionCount: 0,
      };
    }
    case MANAGER_READY: {
      return {
        ...state,
        managerReady: true,
      };
    }
    case MANAGER_NOT_READY: {
      return {
        ...state,
        managerReady: false,
      };
    }
    case DESKTOP_APP_UPDATE_MANDATORY: {
      return {
        ...state,
        isUpdateMandatory: payload,
      };
    }
    case SET_MANAGER_API_TOKEN: {
      return {
        ...state,
        managerApiToken: payload,
      };
    }
    default:
      return state;
  }
};

export default desktopAppReducer;
